/**********************************************************
Chemical View
**********************************************************/
import ChemicalForm from './chemical_form';
import ChemicalList from './chemical_list';
import ProductView from './product_view';
import { createOrEditChemical, fetchChemicals,
  selectChemical, selectChemicalToEdit, clearForm, sendFile } from '../../actions/chem_actions';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
const $ = window.$;

class ChemicalView extends Component {
  componentDidMount() {
    $('#chemical-nav').tabs();
    if (this.props.chemicalList.length === 0) this.props.fetchChemicals();
  }
  render() {
    return (
      <div className="row chemical-reports-view">
        <ul id="chemical-nav" className="tabs tabs-fixed-width">
          <li className="tab col s3"><a className="active chemical-tab-nav" href="#products">Chemical Products</a></li>
          { Object.keys(this.props.user).length === 0 ? ''
            : this.props.user.level >= 3 || this.props.user.positionTitle.match(/Cultivation/) ?
              <li className="tab col s3"><a className="chemical-tab-nav" href="#manage-products">Create & Edit Products</a></li>
            : ''
          }
        </ul>
        <div id="products">
          <div className="col s12 m3 l3 xl3">
            <div className="chem-container chem-list">
              <ChemicalList chemicalList={this.props.chemicalList} onClick={this.props.selectChemical} />
            </div>
          </div>
          <div className="col s12 m9 l9 xl9">
            <ProductView selectedChemical={this.props.selectedChemical} onClick={this.props.sendFile} email={this.props.user.email} />
          </div>
        </div>
        {
          Object.keys(this.props.user).length === 0 ? ''
          : this.props.user.level >= 3 || this.props.user.positionTitle.match(/Cultivation/) ?
              <div id="manage-products">
                <div className="col s12 m3 l3 xl3">
                  <div className="chem-container chem-list">
                    <ChemicalList chemicalList={this.props.chemicalList} onClick={this.props.selectChemicalToEdit} />
                  </div>
                </div>
                <div className="col s12 m9 l9 xl9">
                  <ChemicalForm createOrEditChemical={this.props.createOrEditChemical} editChemical={this.props.editChemical}
                    clearForm={this.props.clearForm} editedChemical={this.props.editedChemical} isEditing={this.props.isEditing}
                    eid={this.props.user.eid} />
                </div>
              </div>
          : ''
        }


      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    chemicalList: state.cultivation.chemical.chemicalList,
    isEditing: state.cultivation.chemical.edit.isEditing,
    editedChemical: state.cultivation.chemical.edit.editedChemical,
    selectedChemical: state.cultivation.chemical.selectedChemical,
    user: state.auth.user
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    clearForm,
    createOrEditChemical,
    sendFile,
    fetchChemicals,
    selectChemical,
    selectChemicalToEdit
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(ChemicalView);



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/chemical/chemical_view.js